import { render, staticRenderFns } from "./PersonalFolderListContainer.vue?vue&type=template&id=61ad586e"
import script from "./PersonalFolderListContainer.ts?vue&type=script&lang=ts&external"
export * from "./PersonalFolderListContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports